import http from './axios';

export default class EsServices {
  constructor() {}

  async search(index: string, params?: any) {
    index = index.toLowerCase();
    let res: any = await http.get(`/v1/search/${index}/page`, { params: params });
    return res.payload;
  }
}
